import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=48278585&"
var script = {}
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=48278585&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports